import User from "../models/user.model";

type RoleAwareUser = Pick<User, "role" | "roles" | "curator" | "institutionId"> | null | undefined;

const ADMIN_CAPABILITY_ROLES = new Set(["GALLERY", "ADMIN", "SUPERADMIN"]);
const STRICT_ADMIN_CAPABILITY_ROLES = new Set(["ADMIN", "SUPERADMIN"]);
const ARTWORK_WORKSPACE_ROLES = new Set(["SELLER", "GALLERY", "ADMIN", "SUPERADMIN"]);

export const getNormalizedUserRoles = (user: RoleAwareUser): string[] => {
  const roles = new Set<string>();

  if (Array.isArray(user?.roles)) {
    user.roles
      .filter((role): role is string => typeof role === "string" && role.trim().length > 0)
      .forEach((role) => roles.add(role));
  }

  if (typeof user?.role === "string" && user.role.trim().length > 0) {
    roles.add(user.role);
  }

  return Array.from(roles);
};

export const hasAdminCapability = (user: RoleAwareUser): boolean =>
  getNormalizedUserRoles(user).some((role) => ADMIN_CAPABILITY_ROLES.has(role));

export const hasStrictAdminCapability = (user: RoleAwareUser): boolean =>
  getNormalizedUserRoles(user).some((role) => STRICT_ADMIN_CAPABILITY_ROLES.has(role));

export const hasEdmCuratorCapability = (user: RoleAwareUser): boolean => {
  const roles = getNormalizedUserRoles(user);

  return hasAdminCapability(user)
    || (roles.includes("SELLER") && user?.curator === true && Boolean(user?.institutionId));
};

export const canAccessArtworkWorkspace = (user: RoleAwareUser): boolean =>
  getNormalizedUserRoles(user).some((role) => ARTWORK_WORKSPACE_ROLES.has(role));
